import React, { PropsWithChildren, useMemo } from 'react'
import { AppLogger, LoggerConfig } from '../../common/logger'
import { LoggerContext } from './hooks/useLogger'

interface LoggerProviderProps {
  config?: LoggerConfig
}

export const LoggerProvider: React.FC<PropsWithChildren<LoggerProviderProps>> = ({ config, children }) => {
  const logger = useMemo(() => {
    const newLogger = new AppLogger()
    const traceId = config?.traceId ?? 'no-trace-id'
    const loggers = config?.loggers ?? ['db']
    const logToConsole = config?.logToConsole ?? false
    const logLevelsToConsole = config?.logLevelsToConsole ?? []
    const fallbackLoggerEnabled = config?.fallbackLoggerEnabled ?? true
    const showDebugWindow = config?.showDebugWindow ?? false
    newLogger.init({ traceId, loggers, logToConsole, logLevelsToConsole, fallbackLoggerEnabled, showDebugWindow })
    return newLogger
  }, [config])

  return <LoggerContext.Provider value={logger}>{children}</LoggerContext.Provider>
}
